import { ChangeDetectionStrategy, Component } from '@angular/core';

import {RouterOutlet} from '@angular/router';
import { LoadingBar } from '@components/partials/loading-bar/loading-bar';
import { SnackbarHost } from '@components/partials/snackbar-host/snackbar-host';


@Component({
  selector: 'app-root',
  imports: [LoadingBar, RouterOutlet, SnackbarHost],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {

}
